/* =====================================================================
   DUHA MAISON — storefront behaviour
   Plain JavaScript, no dependencies. Every module is independent: if one
   fails, the others and the page itself keep working, and every link and
   form still works without JavaScript.
   ===================================================================== */
(function () {
  'use strict';

  var D = window.Duha || {};
  var R = D.routes || {};
  var S = D.strings || {};
  var $ = function (sel, root) { return (root || document).querySelector(sel); };
  var $$ = function (sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); };
  var docEl = document.documentElement;

  function safe(name, fn) {
    try { fn(); } catch (e) { if (window.console) console.warn('[duha] ' + name, e); }
  }

  function debounce(fn, ms) {
    var t;
    return function () {
      var args = arguments, self = this;
      clearTimeout(t);
      t = setTimeout(function () { fn.apply(self, args); }, ms);
    };
  }

  function parseHTML(html) {
    return new DOMParser().parseFromString(html, 'text/html');
  }

  /* Money, in the same shape as snippets/money.liquid */
  function money(cents) {
    var value = (Number(cents) || 0) / 100;
    var amount = value.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).replace(/\.00$/, '');
    var m = D.money || { template: '__C__ __A__', currency: 'AED' };
    return m.template.replace('__A__', amount).replace('__C__', m.currency);
  }

  /* Toast ------------------------------------------------------------- */
  var toastTimer;
  function toast(message) {
    var el = $('[data-toast]');
    if (!el || !message) return;
    el.textContent = message;
    el.classList.add('is-on');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { el.classList.remove('is-on'); }, 2600);
  }

  /* Drawers & focus -------------------------------------------------- */
  var openStack = [];
  var FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select, textarea, [tabindex]:not([tabindex="-1"])';

  function lock() { docEl.classList.toggle('is-locked', openStack.length > 0); }

  function isStaticFacets(drawer) {
    return drawer.classList.contains('drawer--facets') && window.matchMedia('(min-width: 990px)').matches;
  }

  function openDrawer(id, opener, instant) {
    var drawer = document.getElementById(id);
    if (!drawer || isStaticFacets(drawer)) return;
    if (drawer.classList.contains('is-open')) return;
    drawer.__opener = opener || document.activeElement;
    if (instant) drawer.style.transition = 'none';
    drawer.classList.add('is-open');
    openStack.push(drawer);
    lock();
    $$('[aria-controls="' + id + '"]').forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
    var panel = $('.drawer__panel', drawer);
    if (panel) setTimeout(function () { panel.focus({ preventScroll: true }); }, instant ? 0 : 60);
    if (drawer.hasAttribute('data-wishlist-drawer')) Wishlist.render();
    if (instant) requestAnimationFrame(function () { drawer.style.transition = ''; });
  }

  function closeDrawer(drawer) {
    if (!drawer || !drawer.classList.contains('is-open')) return;
    drawer.classList.remove('is-open');
    openStack = openStack.filter(function (d) { return d !== drawer; });
    lock();
    $$('[aria-controls="' + drawer.id + '"]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
    var opener = drawer.__opener;
    if (opener && document.body.contains(opener)) opener.focus({ preventScroll: true });
  }

  function trapFocus(e) {
    var top = openStack[openStack.length - 1];
    if (!top || e.key !== 'Tab') return;
    var items = $$(FOCUSABLE, top).filter(function (el) { return el.offsetParent !== null; });
    if (!items.length) return;
    var first = items[0], last = items[items.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  }

  /* Modals (search, pop-up) share the stack so Escape and locking work */
  function openModal(el) {
    if (!el) return;
    el.__opener = document.activeElement;
    el.hidden = false;
    el.classList.add('is-open');
    openStack.push(el);
    lock();
  }
  function closeModal(el) {
    if (!el || el.hidden) return;
    el.hidden = true;
    el.classList.remove('is-open');
    openStack = openStack.filter(function (d) { return d !== el; });
    lock();
    if (el.__opener && document.body.contains(el.__opener)) el.__opener.focus({ preventScroll: true });
  }

  function initOverlays() {
    document.addEventListener('click', function (e) {
      var opener = e.target.closest('[data-drawer-open]');
      if (opener) {
        e.preventDefault();
        var current = opener.closest('.drawer.is-open');
        if (current && current.id !== opener.getAttribute('data-drawer-open')) closeDrawer(current);
        openDrawer(opener.getAttribute('data-drawer-open'), opener);
        return;
      }
      var closer = e.target.closest('[data-drawer-close]');
      if (closer) { e.preventDefault(); closeDrawer(closer.closest('.drawer')); return; }

      var cartLink = e.target.closest('[data-cart-open]');
      if (cartLink && D.cartType === 'drawer' && document.getElementById('cart-drawer')) {
        e.preventDefault();
        openDrawer('cart-drawer', cartLink);
      }
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && openStack.length) {
        var top = openStack[openStack.length - 1];
        if (top.classList.contains('drawer')) closeDrawer(top);
        else closeModal(top);
      }
      trapFocus(e);
    });
  }

  /* Header ------------------------------------------------------------- */
  function initHeader() {
    var header = $('[data-header]');
    if (header) {
      var onScroll = function () { header.classList.toggle('is-scrolled', window.scrollY > 4); };
      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll();
    }
    var drops = $$('[data-dropdown]');
    drops.forEach(function (d) {
      d.addEventListener('toggle', function () {
        if (d.open) drops.forEach(function (o) { if (o !== d) o.open = false; });
      });
    });
    document.addEventListener('click', function (e) {
      drops.forEach(function (d) { if (d.open && !d.contains(e.target)) d.open = false; });
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') drops.forEach(function (d) {
        if (d.open) { d.open = false; var s = $('summary', d); if (s) s.focus(); }
      });
    });
    // On phones the announcement messages take turns
    var items = $$('.announce__item');
    if (items.length > 1) {
      var i = 0;
      setInterval(function () {
        items[i].classList.remove('is-active');
        i = (i + 1) % items.length;
        items[i].classList.add('is-active');
      }, 4500);
    }
  }

  /* Cart --------------------------------------------------------------- */
  function cartSectionIds() {
    var ids = [];
    if (document.getElementById('cart-drawer')) ids.push('cart-drawer');
    ids.push('cart-icon-bubble');
    var page = $('[data-cart-page]');
    if (page) ids.push(page.getAttribute('data-section-id'));
    return ids;
  }

  function renderCartSections(sections) {
    if (!sections) return;
    if (sections['cart-icon-bubble'] != null) {
      var bubble = document.getElementById('CartBubble');
      var doc = parseHTML(sections['cart-icon-bubble']);
      var src = doc.querySelector('.shopify-section') || doc.body;
      if (bubble) bubble.innerHTML = src.innerHTML;
    }
    if (sections['cart-drawer'] != null) {
      var inner = $('[data-cart-inner]');
      var fresh = parseHTML(sections['cart-drawer']).querySelector('[data-cart-inner]');
      if (inner && fresh) inner.innerHTML = fresh.innerHTML;
    }
    var page = $('[data-cart-page]');
    if (page) {
      var id = page.getAttribute('data-section-id');
      if (sections[id] != null) {
        var next = parseHTML(sections[id]).querySelector('[data-cart-page]');
        if (next) { page.replaceWith(next); Reveal.scan(next); }
      }
    }
  }

  function addToCart(form) {
    var button = $('[type="submit"]', form);
    var error = $('[data-form-error]', form);
    if (error) { error.hidden = true; error.textContent = ''; }
    if (button) { button.classList.add('is-loading'); button.setAttribute('aria-disabled', 'true'); }
    var body = new FormData(form);
    body.append('sections', cartSectionIds().join(','));
    body.append('sections_url', window.location.pathname);
    return fetch(R.cartAdd, {
      method: 'POST',
      headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' },
      body: body
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data.status) throw new Error(data.description || data.message || S.addError);
        if (D.cartType !== 'drawer' || !document.getElementById('cart-drawer')) {
          window.location.href = R.cart;
          return;
        }
        renderCartSections(data.sections);
        openDrawer('cart-drawer', button);
        toast(S.added);
      })
      .catch(function (err) {
        var msg = (err && err.message) || S.addError;
        if (error) { error.textContent = msg; error.hidden = false; } else toast(msg);
      })
      .finally(function () {
        if (button) { button.classList.remove('is-loading'); button.removeAttribute('aria-disabled'); }
      });
  }

  function changeLine(line, quantity) {
    var row = $('[data-line="' + line + '"]');
    $$('[data-line="' + line + '"]').forEach(function (el) { el.classList.add('is-busy'); });
    return fetch(R.cartChange, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' },
      body: JSON.stringify({ line: Number(line), quantity: Math.max(0, Number(quantity) || 0), sections: cartSectionIds(), sections_url: window.location.pathname })
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data.status) throw new Error(data.description || data.message);
        renderCartSections(data.sections);
      })
      .catch(function (err) {
        toast((err && err.message) || S.cartError);
        if (row) row.classList.remove('is-busy');
      });
  }

  var saveNote = debounce(function (value) {
    fetch(R.cartUpdate, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ note: value })
    });
  }, 500);

  function initCart() {
    document.addEventListener('submit', function (e) {
      var form = e.target.closest('[data-product-form]');
      if (!form || !R.cartAdd || !window.fetch) return;
      e.preventDefault();
      addToCart(form);
    });

    document.addEventListener('click', function (e) {
      var step = e.target.closest('[data-qty-step]');
      if (step) {
        var box = step.closest('[data-qty]');
        var input = box && $('.qty__input', box);
        if (!input) return;
        var min = Number(input.min || 0);
        var next = Math.max(min, (Number(input.value) || 0) + Number(step.getAttribute('data-qty-step')));
        if (next === Number(input.value)) return;
        input.value = next;
        input.dispatchEvent(new Event('change', { bubbles: true }));
        return;
      }
      var remove = e.target.closest('[data-line-remove]');
      if (remove && R.cartChange) {
        e.preventDefault();
        changeLine(remove.getAttribute('data-line-remove'), 0);
      }
    });

    document.addEventListener('change', function (e) {
      var qty = e.target.closest('[data-line-qty]');
      if (qty) { changeLine(qty.getAttribute('data-line-qty'), qty.value); return; }
      var note = e.target.closest('[data-cart-note]');
      if (note && !note.closest('form[action]')) saveNote(note.value);
    });
    document.addEventListener('input', function (e) {
      var note = e.target.closest('[data-cart-note]');
      if (note && !note.closest('form[action]')) saveNote(note.value);
    });
  }

  /* Variant picker ------------------------------------------------------ */
  function initVariants() {
    document.addEventListener('change', function (e) {
      var radio = e.target.closest('[data-variant-picker] input[type="radio"]');
      if (!radio) return;
      var picker = radio.closest('[data-variant-picker]');
      var section = picker.closest('[data-product-section]');
      var variants = JSON.parse($('[data-variants-json]', picker).textContent);
      var chosen = [];
      $$('input[type="radio"]:checked', picker).forEach(function (r) { chosen[Number(r.getAttribute('data-option-index'))] = r.value; });
      $$('[data-option-value]', picker).forEach(function (el) { el.textContent = chosen[Number(el.getAttribute('data-option-value'))] || ''; });

      var variant = variants.find(function (v) {
        return v.options.every(function (opt, i) { return opt === chosen[i]; });
      });

      var idInput = $('[data-variant-id]', section);
      var button = $('[data-add-button]', section);
      var label = $('[data-add-label]', section);
      var priceWrap = $('[data-price-wrap]', section);

      if (!variant) {
        if (button) button.disabled = true;
        if (label) label.textContent = S.unavailable;
        return;
      }
      if (idInput) idInput.value = variant.id;
      if (button) button.disabled = !variant.available;
      if (label) label.textContent = variant.available ? S.addToCart : S.soldOut;
      if (priceWrap) {
        var sale = variant.compare_at_price && variant.compare_at_price > variant.price;
        priceWrap.innerHTML = '<div class="price price--lg' + (sale ? ' price--sale' : '') + '"><span class="price__now">' + money(variant.price) + '</span>' +
          (sale ? '<s class="price__was">' + money(variant.compare_at_price) + '</s>' : '') + '</div>';
      }
      var url = picker.getAttribute('data-url');
      if (url && window.history.replaceState) window.history.replaceState({}, '', url + '?variant=' + variant.id);
      if (variant.featured_media) Gallery.show(section, variant.featured_media.id);
    });
  }

  /* Gallery -------------------------------------------------------------- */
  var Gallery = {
    show: function (section, mediaId) {
      var item = $('[data-media-id="' + mediaId + '"]', section);
      if (!item) return;
      var track = item.parentElement;
      if (window.matchMedia('(max-width: 989px)').matches) {
        track.scrollTo({ left: item.offsetLeft - track.offsetLeft - (track.clientWidth - item.clientWidth) / 2, behavior: 'smooth' });
      } else {
        item.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      }
    },
    init: function () {
      $$('[data-gallery]').forEach(function (gallery) {
        var track = $('[data-gallery-track]', gallery);
        var dots = $$('.gallery__dots span', gallery);
        if (!track || dots.length < 2) return;
        track.addEventListener('scroll', debounce(function () {
          var items = $$('.gallery__item', track);
          var center = track.scrollLeft + track.clientWidth / 2;
          var best = 0, dist = Infinity;
          items.forEach(function (it, i) {
            var c = it.offsetLeft - track.offsetLeft + it.clientWidth / 2;
            var d = Math.abs(c - center);
            if (d < dist) { dist = d; best = i; }
          });
          dots.forEach(function (dot, i) { dot.classList.toggle('is-active', i === best); });
        }, 60), { passive: true });
      });
    }
  };

  /* Filters & sorting ------------------------------------------------------ */
  function initFacets() {
    var busy = false;

    function load(url, push) {
      var root = $('[data-facets-root]');
      if (!root || busy) return;
      busy = true;
      var results = $('[data-facets-results]', root);
      if (results) results.classList.add('is-loading');
      var drawer = $('.drawer--facets', root);
      var wasOpen = drawer && drawer.classList.contains('is-open');
      var sectionId = root.getAttribute('data-section-id');
      var fetchUrl = url + (url.indexOf('?') > -1 ? '&' : '?') + 'section_id=' + encodeURIComponent(sectionId);
      fetch(fetchUrl)
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var next = parseHTML(html).querySelector('[data-facets-root]');
          if (!next) { window.location.href = url; return; }
          if (wasOpen) { openStack = openStack.filter(function (d) { return d !== drawer; }); }
          root.replaceWith(next);
          Reveal.scan(next);
          Wishlist.sync();
          if (wasOpen) {
            var fresh = $('.drawer--facets', next);
            if (fresh) openDrawer(fresh.id, null, true);
          }
          if (push) window.history.pushState({ facets: true }, '', url);
        })
        .catch(function () { window.location.href = url; })
        .finally(function () { busy = false; });
    }

    function urlFromForm(form) {
      var params = new URLSearchParams();
      new FormData(form).forEach(function (value, key) { if (value !== '') params.append(key, value); });
      return window.location.pathname + '?' + params.toString();
    }

    var submitSoon = debounce(function (form) { load(urlFromForm(form), true); }, 350);
    var submitLater = debounce(function (form) { load(urlFromForm(form), true); }, 800);

    document.addEventListener('change', function (e) {
      var form = e.target.closest('[data-facets-form]');
      if (form) { submitSoon(form); return; }
      var sort = e.target.closest('[data-sort-select]');
      if (sort) {
        var root = sort.closest('[data-facets-root]');
        var f = root && $('[data-facets-form]', root);
        if (f) {
          var mirror = $('[data-sort-mirror]', f);
          if (mirror) mirror.value = sort.value;
          load(urlFromForm(f), true);
        } else {
          var params = new URLSearchParams(window.location.search);
          params.set('sort_by', sort.value);
          load(window.location.pathname + '?' + params.toString(), true);
        }
      }
    });
    document.addEventListener('input', function (e) {
      if (e.target.matches('[data-facets-form] input[type="number"]')) submitLater(e.target.form);
    });
    document.addEventListener('submit', function (e) {
      var form = e.target.closest('[data-facets-form]');
      if (!form) return;
      e.preventDefault();
      var drawer = form.closest('.drawer');
      if (drawer && drawer.classList.contains('is-open')) { closeDrawer(drawer); return; }
      load(urlFromForm(form), true);
    });
    document.addEventListener('click', function (e) {
      var link = e.target.closest('a[data-facet-link]');
      if (!link || e.metaKey || e.ctrlKey) return;
      e.preventDefault();
      load(link.getAttribute('href'), true);
      if (link.closest('.pagination')) {
        var root = $('[data-facets-root]');
        if (root) root.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
    window.addEventListener('popstate', function (e) {
      if (e.state && e.state.facets) load(window.location.pathname + window.location.search, false);
    });
  }

  /* Predictive search -------------------------------------------------------- */
  function initSearch() {
    var modal = $('[data-search-modal]');
    if (!modal) return;
    var input = $('[data-predictive-input]', modal);
    var results = $('[data-predictive-results]', modal);
    var controller;

    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-search-open]')) {
        e.preventDefault();
        openModal(modal);
        setTimeout(function () { input.focus(); }, 30);
      } else if (e.target.closest('[data-search-close]')) {
        closeModal(modal);
      }
    });

    var run = debounce(function () {
      var q = input.value.trim();
      if (q.length < 2) { results.innerHTML = ''; return; }
      if (controller) controller.abort();
      controller = window.AbortController ? new AbortController() : null;
      var url = R.predictiveSearch + '?q=' + encodeURIComponent(q) +
        '&section_id=predictive-search&resources[type]=product,collection,page&resources[limit]=6&resources[options][fields]=title,product_type,variants.title,vendor';
      fetch(url, controller ? { signal: controller.signal } : {})
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = parseHTML(html);
          var node = doc.querySelector('.shopify-section') || doc.body;
          results.innerHTML = node.innerHTML;
        })
        .catch(function () {});
    }, 220);
    input.addEventListener('input', run);
  }

  /* Recommendations ---------------------------------------------------------- */
  function initRecommendations() {
    $$('[data-recommendations]').forEach(function (el) {
      var url = el.getAttribute('data-url');
      if (!url || el.children.length) return;
      var load = function () {
        fetch(url).then(function (r) { return r.text(); }).then(function (html) {
          var next = parseHTML(html).querySelector('[data-recommendations]');
          if (next && next.innerHTML.trim()) {
            el.innerHTML = next.innerHTML;
            Reveal.scan(el);
            Wishlist.sync();
          } else {
            el.remove();
          }
        });
      };
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          if (entries[0].isIntersecting) { io.disconnect(); load(); }
        }, { rootMargin: '400px 0px' });
        io.observe(el);
      } else load();
    });
  }

  /* Wishlist (kept in this browser) -------------------------------------------- */
  var Wishlist = {
    key: 'duha:wishlist',
    read: function () {
      try { return JSON.parse(localStorage.getItem(this.key) || '[]') || []; } catch (e) { return []; }
    },
    write: function (list) {
      try { localStorage.setItem(this.key, JSON.stringify(list)); } catch (e) {}
    },
    toggle: function (handle) {
      var list = this.read();
      var i = list.indexOf(handle);
      if (i > -1) list.splice(i, 1); else list.unshift(handle);
      this.write(list.slice(0, 50));
      this.sync();
    },
    sync: function () {
      var list = this.read();
      $$('[data-wishlist-toggle]').forEach(function (b) {
        var on = list.indexOf(b.getAttribute('data-wishlist-toggle')) > -1;
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
        var label = b.getAttribute('aria-label') || '';
        var name = label.indexOf(':') > -1 ? label.slice(label.indexOf(':')) : '';
        b.setAttribute('aria-label', (on ? S.wishlistRemove : S.wishlistAdd) + name);
      });
      $$('[data-wishlist-count]').forEach(function (el) {
        el.textContent = list.length;
        el.hidden = list.length === 0;
      });
    },
    render: function () {
      var box = $('[data-wishlist-items]');
      var empty = $('[data-wishlist-empty]');
      if (!box) return;
      var list = this.read();
      if (empty) empty.hidden = list.length > 0;
      box.innerHTML = '';
      var root = (R.root || '/').replace(/\/?$/, '/');
      list.forEach(function (handle) {
        fetch(root + 'products/' + encodeURIComponent(handle) + '.js')
          .then(function (r) { if (!r.ok) throw new Error(); return r.json(); })
          .then(function (p) {
            var li = document.createElement('li');
            li.className = 'line';
            var img = p.featured_image
              ? '<img src="' + p.featured_image + (p.featured_image.indexOf('?') > -1 ? '&' : '?') + 'width=200" alt="" loading="lazy">'
              : '';
            li.innerHTML =
              '<a class="line__media" href="' + p.url + '" tabindex="-1" aria-hidden="true">' + img + '</a>' +
              '<div class="line__info"><a class="line__title" href="' + p.url + '"></a>' +
              '<p class="line__meta">' + money(p.price) + '</p>' +
              '<button type="button" class="line__remove" data-wishlist-toggle="' + handle + '" aria-pressed="true">' + (S.remove || 'Remove') + '</button></div>';
            li.querySelector('.line__title').textContent = p.title;
            box.appendChild(li);
          })
          .catch(function () { Wishlist.toggle(handle); });
      });
    },
    init: function () {
      var self = this;
      document.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-wishlist-toggle]');
        if (!btn) return;
        e.preventDefault();
        self.toggle(btn.getAttribute('data-wishlist-toggle'));
        if (btn.closest('[data-wishlist-items]')) self.render();
      });
      this.sync();
    }
  };

  /* Pop-up -------------------------------------------------------------------- */
  function initPopup() {
    var popup = $('[data-popup]');
    if (popup) {
      var key = 'duha:popup-seen';
      var seen = false;
      try { seen = localStorage.getItem(key) === '1'; } catch (e) {}
      var posted = /customer_posted=true/.test(window.location.search) && window.location.hash === '#PopupNewsletter';
      var close = function () {
        closeModal(popup);
        try { localStorage.setItem(key, '1'); } catch (e) {}
      };
      popup.addEventListener('click', function (e) { if (e.target.closest('[data-popup-close]')) close(); });
      if (posted) openModal(popup);
      else if (!seen) {
        setTimeout(function () {
          if (!openStack.length) { openModal(popup); var p = $('.modal__panel', popup); if (p) p.focus(); }
        }, (Number(popup.getAttribute('data-delay')) || 8) * 1000);
      }
    }
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-copy]');
      if (!btn) return;
      var text = btn.getAttribute('data-copy');
      if (navigator.clipboard) navigator.clipboard.writeText(text).then(function () { toast(S.codeCopied); });
    });
  }

  /* Share -------------------------------------------------------------------- */
  function initShare() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-share]');
      if (!btn) return;
      var url = btn.getAttribute('data-share-url') || window.location.href;
      var title = btn.getAttribute('data-share-title') || document.title;
      if (navigator.share) navigator.share({ title: title, url: url }).catch(function () {});
      else if (navigator.clipboard) navigator.clipboard.writeText(url).then(function () { toast(S.linkCopied); });
    });
  }

  /* Language & country switch ------------------------------------------------- */
  function initLocalization() {
    document.addEventListener('change', function (e) {
      var sel = e.target.closest('[data-autosubmit]');
      if (sel && sel.form) sel.form.submit();
    });
  }

  /* Reveal on scroll ------------------------------------------------------------ */
  var Reveal = {
    io: null,
    init: function () {
      docEl.classList.add('reveal-ready');
      var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (!document.body.classList.contains('has-motion') || reduce || !('IntersectionObserver' in window)) {
        $$('.reveal').forEach(function (el) { el.classList.add('is-in'); });
        return;
      }
      this.io = new IntersectionObserver(function (entries, io) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) { entry.target.classList.add('is-in'); io.unobserve(entry.target); }
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
      this.scan(document);
    },
    scan: function (root) {
      var self = this;
      $$('.reveal:not(.is-in)', root).forEach(function (el, i) {
        if (!self.io) { el.classList.add('is-in'); return; }
        el.style.transitionDelay = Math.min(i % 4, 3) * 70 + 'ms';
        self.io.observe(el);
      });
    }
  };

  /* Theme editor: re-run what a freshly rendered section needs ------------------ */
  function initEditor() {
    if (!window.Shopify || !window.Shopify.designMode) return;
    document.addEventListener('shopify:section:load', function (e) {
      $$('.reveal', e.target).forEach(function (el) { el.classList.add('is-in'); });
      Wishlist.sync();
      Gallery.init();
    });
  }

  function boot() {
    safe('overlays', initOverlays);
    safe('header', initHeader);
    safe('cart', initCart);
    safe('variants', initVariants);
    safe('gallery', function () { Gallery.init(); });
    safe('facets', initFacets);
    safe('search', initSearch);
    safe('recommendations', initRecommendations);
    safe('wishlist', function () { Wishlist.init(); });
    safe('popup', initPopup);
    safe('share', initShare);
    safe('localization', initLocalization);
    safe('reveal', function () { Reveal.init(); });
    safe('editor', initEditor);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
